import React from 'react'
import styled from 'styled-components'
// @ts-ignore
import { sys } from '@netbasequid/theme'
// @ts-ignore
import { Skeleton } from '@netbasequid/core'
import { useDisplayTheme } from 'hooks/useUiState'
import { Theme } from 'features/ui/types'

const StyledGroupContainer = styled.div`
  margin: 0 -16px;
`

const StyledContainer = styled.div<{ mode: Theme }>`
  display: flex;
  gap: 12px;
  padding: 8px 16px;
  border-top: 1px solid ${({ mode }) => sys[mode].common.divider[100]};
`

const AVATAR_SKELETON_WIDTH = '32px'
const AVATAR_SKELETON_HEIGHT = '32px'

const CONTENT_SKELETON_WIDTH = '688px'
const CONTENT_SKELETON_HEIGHT = '102px'

const LOADING_PLACEHOLDER_COUNT = 3

const LoadingSoundbiteGroup = () => {
  const theme = useDisplayTheme()

  return (
    <StyledGroupContainer>
      {Array(LOADING_PLACEHOLDER_COUNT)
        .fill(0)
        .map((_, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <StyledContainer key={index} mode={theme}>
            <Skeleton
              mode={theme}
              variation="circle"
              width={AVATAR_SKELETON_WIDTH}
              height={AVATAR_SKELETON_HEIGHT}
              animation="wave"
            />
            <Skeleton
              mode={theme}
              variation="rectangle"
              width={CONTENT_SKELETON_WIDTH}
              height={CONTENT_SKELETON_HEIGHT}
              animation="wave"
            />
          </StyledContainer>
        ))}
    </StyledGroupContainer>
  )
}

export default LoadingSoundbiteGroup
